import { primitivesToOptions } from "../contexts/DropdownContext";

export const RoleConstants = {
  SUPER_ADMIN: "Super Admin",
  BASIC: "Basic",
};

export const RoleSelectionOptions = primitivesToOptions(Object.values(RoleConstants));
